exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".registration-group-table img[data-v-53defa4e]{cursor:pointer}tr.text-red td[data-v-53defa4e]{color:red!important}", "", {"version":3,"sources":["F:/myugfront/src/components/registration/must-change-subjects-modal.vue"],"names":[],"mappings":"AACA,+CACI,cAAgB,CACnB,AACD,gCACE,mBAAuB,CACxB","file":"must-change-subjects-modal.vue","sourcesContent":["\n.registration-group-table img[data-v-53defa4e] {\n    cursor: pointer;\n}\ntr.text-red td[data-v-53defa4e] {\n  color: #f00 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-53defa4e","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/must-change-subjects-modal.vue
// module id = 980
// module chunks = 1